import { action, makeObservable, observable, observe } from 'mobx';
import { getGlobalStats } from '../api';
import GlobalStatistics from '../model/GlobalStatistics';
import SubscriberData from '../model/SubscriberData';
import AuthStore from './AuthStore';

class DashboardStore {
  statistics?: GlobalStatistics;

  subscriberData?: SubscriberData;

  loading = true;

  authStore: AuthStore;

  constructor(authStore: AuthStore) {
    this.authStore = authStore;
    makeObservable(this, {
      statistics: observable,
      subscriberData: observable,
      loading: observable,
      loadStatistics: action,
    });

    observe(authStore, 'isAdmin', () => {
      if (authStore.user && authStore.isAdmin) {
        this.loadStatistics();
      }
    });
  }

  loadStatistics = async (): Promise<void> => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    await this.getGlobalStats(currentMonth, currentYear);

    this.loading = false;
  };

  getGlobalStats = async (month: number, year: number): Promise<void> => {
    this.statistics = await getGlobalStats(month, year);
  };
}

export default DashboardStore;
